import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' }
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    cellNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid cell phone number' }
      ]
    },
    eventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future' }
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please provide a type for your event' }
      ]
      },
    operation: {
      validations: [
        { type: 'required', message: 'Please select a catering service' }
      ]
    },
    plannedguestcount: {
      validations: []
    },
    eventextra1: {
      validations: []
    },
    notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'email'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Cell Number:',
            mapping: 'cellNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Event Date:',
            mapping: 'eventDate'
      },
      {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Event Type:*',
            options: [
              { label: 'Wedding'  , value: 'Wedding'},
              { label: 'Corporate/Business'  , value: 'Corporate/Business'},
              { label: 'BBQ/Picnic'  , value: 'BBQ/Picnic'},
              { label: 'Sweet 16'  , value: 'Sweet 16'},
              { label: 'Quinceanera'  , value: 'Quinceanera'},
              { label: 'Bar/Bat Mitzvah'  , value: 'Bar/Bat Mitzvah'},
              { label: 'Other'  , value: 'Other'},
            ],
            mapping: 'theme'
      },
      {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type of Catering Service:*',
            options: [
              { label: 'Drop-Off Catering'  , value: 'Drop-Off Catering'},
              { label: 'Full-Service Catering'  , value: 'Full-Service Catering'},
              { label: 'Catering with Rentals'  , value: 'Catering with Rentals'},
              { label: 'Not Sure Yet'  , value: 'Not Sure Yet'},
            ],
            mapping: 'operation'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of People:',
            mapping: 'plannedguestcount'
      },
      {
            type: 'checkbox-list',
            size: 'Medium',
            label: 'SMS Consent:',
            options: [
              { label: 'Yes', value: 'Yes'},
              { label: 'No', value: 'No'},
            ],
            mapping: 'eventextra1',
         },
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Details About Your Event:',
            mapping: 'notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Jacques Caterers - Service Request Form',
    formId: '235',
    clientKey: '80577D12-B8C8-491A-9EE1-6DD9418F43A7',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: 'https://www.jacquescatering.com/contact/thank-you/',
    submissionText: '',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
